import React from 'react';
import NavCard from './component';

export default React.memo(NavCard);
